import { takeLatest } from 'redux-saga/effects';
import { FETCH_BILLED_PACKAGES_STATUS } from '../../redux/modules/billedMedicalPackageStatus/billedMedicalPackageStatus-actions';
import fetchBilledPackagesStatusWorker from './billedMedicalPackageWorkerStatusSaga';

function* fetchBilledPackagesStatusWatcher() {
    yield takeLatest(FETCH_BILLED_PACKAGES_STATUS, fetchBilledPackagesStatusWorker);
}

export default fetchBilledPackagesStatusWatcher;
